import { throttle } from 'lodash'

export default {
	props: {
		yAutoscroll: { type: Boolean, default: false },
	},
	data () {
		return {
			topSensitivity: 150, // px
			bottomSensitivity: 150, // px
			yScrollSpace: 150, // px
			scrollingContainer: '', // css selector
			timerId: null,
			throttledHandler: null,
			yPosition: null,
		}
	},
	created () {
		if (!this.yAutoscroll) { return }
		this.throttledHandler = throttle(this.handler, 100)
	},
	beforeUnmount () {
		if (this.throttledHandler) {
			window.removeEventListener('drag', this.throttledHandler)
			this.throttledHandler = null
		}
		clearTimeout(this.timerId)
    },
    computed: {
		scrollingElement () {
			if (!this.yAutoscroll) { return {} }
			const el = this.scrollingContainer ? document.querySelector(this.scrollingContainer) : null
			return el || document.scrollingElement
		},
		hasToTop () {
			if (this.yPosition === null) { return false }
			return this.yPosition <= this.topSensitivity
		},
		hasToBottom () {
			if (this.yPosition === null) { return false }
			const { height } = this.$vuetify.breakpoint
			return height - this.yPosition <= this.bottomSensitivity
		},
    },
	watch: {
		hasToTop (val) {
			if (val) {
				this.startScrollingToTop()
			}
		},
		hasToBottom (val) {
			if (val) {
				this.startScrollingToBottom()
			}
		},
	},
    methods: {
		startListening () {
			if (!this.yAutoscroll) { return }
			window.addEventListener('drag', this.throttledHandler)
		},
		stopListening () {
			if (!this.yAutoscroll) { return }
			window.removeEventListener('drag', this.throttledHandler)
		},
		handler (evt) {
			this.yPosition = !evt.x && !evt.y ? null : evt.y
		},
		startScrollingToTop () {
			const { scrollTop } = this.scrollingElement
			if (scrollTop && this.hasToTop) {
				this.timerId = setTimeout(() => { this.startScrollingToTop() }, 100)
				this.scrollingElement.scrollBy?.({
					top: - this.yScrollSpace,
					behavior: 'smooth',
				})
			}
		},
		startScrollingToBottom () {
			const { scrollTop, scrollHeight } = this.scrollingElement
			if (scrollTop < scrollHeight && this.hasToBottom) {
				this.timerId = setTimeout(() => { this.startScrollingToBottom() }, 100)
				this.scrollingElement.scrollBy?.({
					top: this.yScrollSpace,
					behavior: 'smooth',
				})
			}
		},
    },
}
